// Lead-magnet opt-in: submit the customer form without leaving the page, then
// show an in-place success message + "Continue exploring" button.
(function () {
  document.querySelectorAll('form.mm-lm__form').forEach(function (form) {
    var fields = form.querySelector('[data-lm-fields]');
    var success = form.querySelector('[data-lm-success]');
    if (!success) return;

    form.addEventListener('submit', function (e) {
      // Let the browser surface native validation (required / invalid email).
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

      // When a redirect URL is configured, let the form submit natively - the
      // hidden return_to input makes Shopify redirect there after capturing the
      // email. This keeps it a single, server-side redirect (never home).
      if (success.getAttribute('data-lm-redirect')) return;

      // No redirect: capture in the background and show the inline success.
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.setAttribute('disabled', 'true');

      function reveal() {
        if (fields) fields.hidden = true;
        success.classList.remove('is-hidden');
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin'
      }).then(reveal).catch(reveal);
    });
  });
})();
